import '@nldd/design-system';
import '@nldd/design-system/styles';
import './nldd/portal.css';
import './nldd/skin.generated.css';

import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { portaalPlugin } from './modules/portaal';
import { docsProposalModule } from './modules/portaal/DocsProposal';
import { browserModules } from './modules/portaal/browserModules';
import { searchModule } from './modules/portaal/search';
import { shellModule, techdocsStyleModule } from './modules/shell';

export default createApp({
  features: [catalogPlugin, shellModule, techdocsStyleModule, docsProposalModule, searchModule, ...browserModules, portaalPlugin],
});
